import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router'
import { sendHttpPostRequest } from '../../../api/http-request'
import Cookies from 'js-cookie'
import { Col, Layout, Menu, message, Row, Tabs, Empty } from 'antd'
import css from './case-run.module.less'
import css2 from '../CaseDetail/case-detail.module.less'
import '@/static/font/iconfont.css'
import type { MenuProps } from 'antd'
import { FileList } from '../CaseDetail/FileList'
import CopyToClipboard from 'react-copy-to-clipboard'
import GlobalCss from '@/global.module.less'

type MenuItem = Required<MenuProps>['items'][number]
interface Props {}

const Header = (props: any) => {
  const { caseInfo } = props

  return (
    <Row className={css.header} justify={'start'} align={'middle'} wrap={false}>
      <Col className={css.headerTitle}>{caseInfo?.name}</Col>
      <Col className={css.domainTag}>{caseInfo?.domain}</Col>
      <Col
        onClick={() => window.close()}
        style={{ position: 'absolute', right: '20px', cursor: 'pointer' }}
      >
        {'返回 >'}
      </Col>
    </Row>
  )
}
function getItem(
  label: React.ReactNode,
  key: React.Key,
  icon?: React.ReactNode,
  children?: MenuItem[],
  type?: 'group'
): MenuItem {
  return {
    key,
    icon,
    children,
    label,
    type,
  } as MenuItem
}

const items: MenuItem[] = [
  getItem('实验', '1', <span className="iconfont icon_a-zu3672"></span>),
  getItem('数据集', '2', <span className="iconfont icon_a-zu3673"></span>),
]

export const CaseRun: React.FC<Props> = (props: Props) => {
  const location = useLocation()
  const fromCourse = location?.pathname?.includes('course')
  const oamMode = location.pathname.includes('oam')
  const caseId = fromCourse
    ? location?.search?.split('case_id=')[1].split('?')[0]
    : location?.search?.split('case_id=')[1]
  const courseId = location?.search?.split('course_id=')[1]
  const [userLogin, setUserLogin] = useState(false) // 用户登录状态
  const [caseInfo, setCaseInfo] = useState<any>()

  const [collapsed, setCollapsed] = useState(true)

  const [expDatasetInfo, setExpDatasetInfo] = useState<any>()
  const fromOAM = location.pathname?.includes('oam') ? 1 : 0
  const [tabActiveKey, setTabActiveKey] = useState('dataset')
  const [isVisible1, setIsVisible1] = useState(true);
  const [isVisible2, setIsVisible2] = useState(false);
  const [activeMontedDatasetInfo, setActiveMontedDatasetInfo] = useState<any>()

  const MenuItem = (props: any) => {
    const { dataset, onClick, index } = props
  
    return (
      <Row
        onClick={onClick}
        className={
          css2.menuItem +
          ' ' +
          (dataset.dataset_id == activeMontedDatasetInfo?.dataset_id ||
          dataset.dataset_id == activeMontedDatasetInfo?.id
            ? css2.activeMenuItem
            : '')
        }
        align={'top'}
        justify={'space-between'}
        wrap={false}
      >
        <Col>
          <Row
            align={'top'}
            justify={'start'}
            style={{ gap: '10px' }}
            wrap={false}
          >
            <Col>
              <span
                style={{
                  color: '#07C160',
                }}
                className="iconfont icon_a-zu3673"
              ></span>
            </Col>
            <Col>
              <div
                className={css2.dtstTitle + ' ' + GlobalCss.oneLineTextOverflow}
                style={{ maxWidth: '220px' }}
                title={dataset.title}
              >
                {dataset.title}
              </div>
              <CopyToClipboard
                text={'../' + dataset?.base_path}
                onCopy={() => {
                  message.success('路径已复制')
                }}
              >
                <span
                  className={
                    css2.datasetBasePath + ' ' + GlobalCss.oneLineTextOverflow
                  }
                >
                  {dataset?.base_path}
                </span>
              </CopyToClipboard>
            </Col>
          </Row>
        </Col>
      </Row>
    )
  }

  useEffect(() => {
    queryCase()
    return () => {}
  }, [])

  /**
   * 查询实验信息
   */
  const queryCase = () => {
    let params = {
      sessionid: Cookies.get('sessionid'),
      case_id: caseId,
      // is_my: '2',
    }
    // if (caseId) {
    //   params['course_id'] = caseId
    // }
    if (oamMode) {
      sendHttpPostRequest(
        'case/api/oam_query_case_by_id',
        params,
        queryCaseCallback
      )
    } else if (fromCourse) {
      params['course_id'] = courseId
      sendHttpPostRequest(
        'course/api/user_query_course_case_by_id',
        params,
        queryCaseCallback
      )
    } else {
      sendHttpPostRequest(
        'case/api/query_case_by_id',
        params,
        queryCaseCallback
      )
    }
  }

  const getDatasetDetail = () => {
    let data = {
      dataset_id: caseInfo?.dataset_id,
    }

    let api_url = fromOAM == 1? 'dataset/api/oam_get_dataset_by_id/' : 'dataset/api/user_get_dataset_by_id/'

    sendHttpPostRequest(api_url, data, (res) => {
      if (res.code == 0) {
        setExpDatasetInfo(res.query_info)
      }
      if (res.code == -100) {
        message.error(res.message)
      }
    })
  }
  // 切换侧边栏
  const onMenukeyChange = (key) => {
    if(key.key == "1"){
      setIsVisible1(true);
      setIsVisible2(false);
    }else if(key.key == "2"){
      getDatasetDetail();
      setIsVisible2(true);
      setIsVisible1(false);
    }
  }
  //切换页签
  const onTabkeyChange = (key) => {
    setTabActiveKey(key)
    if (key == 'dataset') {
      getDatasetDetail()
    }
  }
  const onMenuClick = (dataset) => {
    queryMountedDatasetInfo(dataset?.dataset_id)
  }

  const queryMountedDatasetInfo = (id) => {
    let data = {
      dataset_id: id,
    }
    sendHttpPostRequest('dataset/api/user_get_dataset_by_id/', data, (res) => {
      if (res.code == 0) {
        setActiveMontedDatasetInfo({
          ...res.query_info,
          dataset_id: res.query_info.id,
        })
      } else {
        message.error(res.message)
      }
    })
  }

  /**
   * 查询实验回调
   * @param response
   */
  const queryCaseCallback = (response: any) => {
    console.log(response)
    message.destroy()
    if (response.code == -100) {
      // 未登录
      setUserLogin(false)
      sessionStorage.setItem("previousurl",window.location.href )
      document.getElementById('show-login-modal')!.click()
    } else if (response.code == 0) {
      setUserLogin(true)
      setCaseInfo(response?.case_info)

      if (response.case_info.mounted_datasets.length > 0 ){
        queryMountedDatasetInfo(response.case_info.mounted_datasets[0].dataset_id)//默认展开第一个挂载数据集信息
      }
    }
  }

  return (
    <Layout style={{ minHeight: '100vh', backgroundColor: '#f9f9f9' }}>
      <Header caseInfo={caseInfo} />
      <div className={css.sideBar}>
        <Menu
          onClick={onMenukeyChange}
          defaultSelectedKeys={['1']}
          // defaultOpenKeys={['sub1']}
          mode="inline"
          theme="light"
          inlineCollapsed={collapsed}
          items={items}
        />
      </div>
      <div className={css.content}>
        <iframe
          id="notebook-iframe"
          sandbox="allow-scripts allow-forms allow-same-origin"
          src={caseInfo?.run_url}
          style={{
            display: isVisible1? 'block' : 'none',
            minHeight: 'calc(100vh - 52px)',
            width: '-webkit-fill-available',
            //borderRadius: 10,
            marginLeft: '50px',
            marginTop: '60px',
          }}
          frameBorder="0"
        />
      </div>
      <div
          style={{
            display: isVisible2? 'block' : 'none',
            minHeight: 'calc(100vh - 52px)',
            width: '-webkit-fill-available',
            //borderRadius: 10,
            marginLeft: '50px',
            padding:'0 24px',
            marginTop: '60px',
            background:'#fff',
          }}
          className={css.datasetWrapper}
        >
          <Tabs defaultActiveKey="dataset" activeKey={tabActiveKey} onChange={onTabkeyChange}>
            <Tabs.TabPane tab="实验数据" key="dataset">
              <div
                id="experiment_dataset_div"
                style={{
                  //padding: '0px 40px 30px 30px',
                  minHeight: '450px',
                }}
              >
                {expDatasetInfo && (
                  <FileList
                    actionPath={location.pathname + location.search}
                    datasetInfo={expDatasetInfo}
                    mode={caseInfo?.is_system || fromCourse ? 'monted' : 'case'}
                    requestType={fromOAM == 1 ? 'oam' : 'user'}
                    tabs='run'
                    dataset_id = {expDatasetInfo?.id}
                  />
                )}
              </div>
            </Tabs.TabPane>
            {caseInfo?.mounted_datasets.length > 0 ? (
              <Tabs.TabPane tab="挂载数据" key="mnt_dataset">
                <div
                  id="mount_dataset_div"
                  style={{
                    //padding: '0px 30px 30px 30px',
                    minHeight: '500px',
                  }}
                >
                  {caseInfo?.mounted_datasets?.length > 0 ? (
                    <Row className={css2.montedContain} wrap={false}>
                      <Col className={css2.montedMenu} flex={'280px'}>
                        {caseInfo?.mounted_datasets?.map((dtst, i) => {
                          return (
                            <MenuItem
                              key={dtst.dataset_id}
                              dataset={dtst}
                              onClick={onMenuClick.bind(this, dtst)}
                              index={i}
                            />
                          )
                        })}
                      </Col>
                      <Col className={css2.montedTable} flex={'auto'}>
                        {activeMontedDatasetInfo && (
                          <div style={{ padding: '0px 0px 0px 12px'}}>
                            {' '}
                            <FileList
                              actionPath={location.pathname + location.search}
                              datasetInfo={activeMontedDatasetInfo}
                              mode={'monted'}
                              requestType={fromOAM == 1 ? 'oam' : 'user'}
                              tabs='run'
                              dataset_id = {activeMontedDatasetInfo?.dataset_id}
                            />
                          </div>
                        )}
                      </Col>
                    </Row>
                  ) : (
                    <div
                      style={{
                        width: '100%',
                        height: '500px',
                        lineHeight: '500px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description={
                          <span style={{ color: '#999999' }}>
                            暂无数据
                          </span>
                        }
                      />
                    </div>
                  )}
                </div>
              </Tabs.TabPane>
            ) : (
              ''
            )}
          </Tabs>
        </div>
    </Layout>
  )
}

export default CaseRun
